'use strict'

import React, { PropTypes }   from 'react'
import FAQ        from './faq'
import Calculator from './calculator'

export default class FrontPage extends React.Component {
  constructor (props) {
    super(props)

    this.testimonials = [{
      key: 'AS1',
      image: 'https://s3.amazonaws.com/uifaces/faces/twitter/ladylexy/128.jpg',
      name: 'Angela Sternberg',
      comment: 'Love this company. ..... I have had my first appointment and they where fantastic. I do have a  lot of work to do but they made it possible'
    }, {
      key: 'BM1',
      image: 'https://dma-au-production.s3.amazonaws.com/trent.jpg',
      name: 'Trent Gibbs',
      comment: 'I am also a very happy customer... Lost lots of teeth due to periodontal disease, and wanted to have my smile back. Instead of recommending implants, they did an amazing bridge work and now, I\'m so happy. They saved me THOUSANDS!'
    }, {
      key: 'EM1',
      image: 'https://s3.amazonaws.com/uifaces/faces/twitter/adellecharles/128.jpg',
      name: 'Emily McLeod',
      comment: 'I already use this plan and it\'s awesome i can\'t afford to pay up front for my dental work and the $99 a week makes it possible and they are none profit so you only pay what for what work you get done I\'m very happy with them DMA team'
    }, {
      key: 'BM2',
      image: 'https://s3.amazonaws.com/uifaces/faces/twitter/kfriedson/128.jpg',
      name: 'Belinda Moroney',
      comment: 'This is great. I didnt have the money upfront to afford my daughters braces. After 2 payments we were able to have a consultation and get the ball rolling. I think of it as a personal loan minus the interest. 45 weeks of $99 payments which gives you  $5000 worth of work. Dont mock it until you have the info. I know my daughter will  have beautiful teeth by the end.'
    }]
  }

  updateLocation (e) {
    this.props.onChange('location', {
      displayName: 'Location',
      value: e.target.value,
      pageRef: 'book-your-appointment',
      order: 11
    })
  }

  onStartClick () {
    window.ga('send', 'event', {
      eventCategory: 'H - Banner Form',
      eventAction: 'Submit',
      eventLabel: 'Start'
    })

    this.props.showSecondForm()
  }

  onStartClickDentist () {
    window.ga('send', 'event', {
      eventCategory: 'H – Local Dentist Form',
      eventAction: 'Submit',
      eventLabel: 'Start'
    })

    this.props.showSecondForm()
  }

  componentDidMount () {
    const { optimizelyToken } = this.context
    window.optimizely.push(['activate', optimizelyToken])
    window.fbq('track', 'ViewContent')
  }

  render () {
    const { termsAndConditions } = this.context
    return (
      <div className='front-page'>
        <img className='front-image' src='assets/images/front.png' />
        <div className='join'>
          <div className='container'>
            <div className='row relative'>
              <div className='front-title'>
                Up to $10,000 Dental Procedures with Easy Weekly Payments
                <h4>No Interest Ever, Capped Pricing*.</h4>
              </div>
              <div className='third'>
                <Calculator onChange={this.props.onChange} showForm={this.onStartClickDentist.bind(this)} />
              </div>
              <div className='third join--message'>
                <h2>How much more confident would you feel with a nice smile?</h2>
                <h3>Dental Members Australia<br />can help you today</h3>
              </div>
              <div className='third join--image'>
                <img src='assets/images/women.png' />
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <div className='quality'>
            <div className='row'>
              <h1>$49 to $99 Weekly Payments<br />Capped Fee Dentistry</h1>
              <div className='third'>
                <svg
                  className='quality-icons'
                  x='0px'
                  y='0px'
                  viewBox='0 0 100 100'
                  enableBackground='new 0 0 100 100'>
                  <path d='M50,92.5c23.4,0,42.5-19.1,42.5-42.5S73.4,7.5,50,7.5S7.5,26.6,7.5,50S26.6,92.5,50,92.5z M50,12.5  c20.7,0,37.5,16.8,37.5,37.5S70.7,87.5,50,87.5S12.5,70.7,12.5,50S29.3,12.5,50,12.5z'
                  />
                  <polygon points='70,47.5 52.5,47.5 52.5,20 47.5,20 47.5,52.5 70,52.5 ' />
                </svg>
                <h2>Estimate the amount of<br />dental work that you need done.</h2>
                <p>
                  Start your treatment after
                  <br />successful payment of $198.
                </p>
              </div>
              <div className='third'>
                <svg
                  className='voucher quality-icons'
                  x='0px'
                  y='0px'
                  viewBox='0 0 34 34'>
                  <g>
                    <path className='st0' d='M10.5,10h-8v3.5c1.7,0.2,3,1.7,3,3.5s-1.3,3.2-3,3.5V24h8V10z' />
                    <path className='st0' d='M31.5,13.5V10h-20v14h20v-3.5c-1.7-0.2-3-1.7-3-3.5S29.8,13.8,31.5,13.5z' />
                    <path className='st1' d='M32,14.5c0.3,0,0.5-0.2,0.5-0.5V9.5C32.5,9.2,32.3,9,32,9H2C1.7,9,1.5,9.2,1.5,9.5V14c0,0.3,0.2,0.5,0.5,0.5
                            c1.4,0,2.5,1.1,2.5,2.5S3.4,19.5,2,19.5c-0.3,0-0.5,0.2-0.5,0.5v4.5C1.5,24.8,1.7,25,2,25h30c0.3,0,0.5-0.2,0.5-0.5V20
                            c0-0.3-0.2-0.5-0.5-0.5c-1.4,0-2.5-1.1-2.5-2.5S30.6,14.5,32,14.5z M2.5,20.5c1.7-0.2,3-1.7,3-3.5s-1.3-3.2-3-3.5V10h8v14h-8V20.5z
                             M31.5,20.5V24h-20V10h20v3.5c-1.7,0.2-3,1.7-3,3.5S29.8,20.2,31.5,20.5z' />
                  </g>
                </svg>
                <h2>Select the voucher<br />amount you need.</h2>
                <p>
                  You can utilise your credit
                  <br />at anytime.
                </p>
              </div>
              <div className='third'>
                <svg
                  className='quality-icons'
                  x='0px'
                  y='0px'
                  viewBox='0 0 100 100'
                  enable-background='new 0 0 100 100'>
                  <g>
                    <path d='M75,5c-8.3,0-17.6,0.9-25,2.4C42.6,5.9,33.3,5,25,5C14,5,5,14,5,25c0,4.5,3.3,10.9,5.4,13.9c0.6,1.2,1.4,7.3,2,12.7   C14.6,69.9,17.6,95,30,95c10.3,0,13-12.4,15.1-22.3C46.2,67.3,47.7,60,50,60c2.8,0,4.4,7.5,5.7,13.6C58,83.6,60.5,95,70,95   c12.7,0,15.6-25.3,17.7-43.7c0.6-5.3,1.3-11.3,1.9-12.5C89.9,38.4,95,29.8,95,25C95,14,86,5,75,5z M85.4,36.2   c-1.1,1.9-1.6,6-2.6,14.5C81.3,63.4,78.2,90,70,90c-5.1,0-7.1-7.3-9.4-17.5c-2-9-3.8-17.5-10.6-17.5c-6.3,0-8,8.1-9.8,16.6   C37.9,82.4,35.8,90,30,90c-8,0-11.1-26.4-12.6-39c-1.1-9-1.6-13.1-2.9-14.9C12.7,33.4,10,27.9,10,25c0-8.3,6.7-15,15-15   c8.1,0,17.3,0.9,24.5,2.4l0.5,0.1l0,0c1.9,0.4,10.2,2.5,18.4,9.4c0.5,0.4,1,0.6,1.6,0.6c0.7,0,1.4-0.3,1.9-0.9   c0.9-1.1,0.7-2.6-0.3-3.5c-3.9-3.3-7.9-5.6-11.3-7.2C65.2,10.3,70.2,10,75,10c8.3,0,15,6.7,15,15C90,27.3,87.3,33,85.4,36.2z'
                    />
                    <path d='M21.7,14.3l2.2,10.8l-7.3,8.3l10.8-2.2l8.3,7.3l-2.2-10.8l7.3-8.3l-10.8,2.2L21.7,14.3z M30.7,26.9l1,4.7l-3.6-3.2l-4.7,1   l3.2-3.6l-1-4.7l3.6,3.2l4.7-1L30.7,26.9z'
                    />
                  </g>
                </svg>
                <h2>Join online and save on<br />your dental procedures.</h2>
                <p>
                  Capped Fee at selected locations
                </p>
              </div>
            </div>
          </div>
          <div className='choose'>
            <div>
                <div className="listbox box-shadow mt-1 mb-1 fees-table">
                  <div className="header">Compare our Fees</div>
                  <div className="box second" style={{ padding: '10px' }}>
                    <table className="full-width">
                      <tbody>
                        <tr>
                          <th>Procedure</th>
                          <th>Average Aust. Fee *</th>
                          <th>DMA Capped Fee</th>
                        </tr>
                        <tr>
                          <td>Comprehensive Exam</td>
                          <td>$66</td>
                          <td>$55</td>
                        </tr>
                        <tr>
                          <td>White Fillings</td>
                          <td>$153 - $304</td>
                          <td>$195</td>
                        </tr>
                        <tr>
                          <td>Root Canal (Front Tooth)</td>
                          <td>$748</td>
                          <td>$700</td>
                        </tr>
                        <tr>
                          <td>Root Canal (Back Tooth)</td>
                          <td>$1,288</td>
                          <td>$1,100</td>
                        </tr>
                        <tr>
                          <td>Full Crown</td>
                          <td>$1,556</td>
                          <td>$1,160</td>
                        </tr>
                        <tr>
                          <td>Crown or Veneer (Non-Metallic)</td>
                          <td>$1,585</td>
                          <td>$999</td>
                        </tr>
                        <tr>
                          <td>Extraction - 1 Tooth</td>
                          <td>$185</td>
                          <td>$149</td>
                        </tr>
                        <tr>
                          <td>Surgical Extraction</td>
                          <td>$375 - $690</td>
                          <td>$450</td>
                        </tr>
                        <tr>
                          <td>Implant + Crown (Per Implant) **</td>
                          <td>$5,015</td>
                          <td>$2,995 - $3,995</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <p>
                  * Australian Dental Association Dental Fees Survey Oct. 2016<br/>
                  ** Gum and bone grafting not included in the Implant fee above. Implant quote may change if more components or procedures are required.<br/>
                  *** Voucher discounts don't apply to Capped Fee Vocuhers.
                </p>
            </div>
            <Calculator className="hidden-desktop" onChange={this.props.onChange} showForm={this.onStartClickDentist.bind(this)} />
            <div>
              <p>
                Dental Members Australia's (DMA) mission is to make visiting the dentist affordable and accessible. We want to help the 70% of Australians in need of dental care.
                <br/><br/>
                Rather than paying for your dental treatment upfront you can now use one of our Dental Vouchers ($1000 to $5000) and pay for your treatment in:
                <br/><br/>
              </p>
              <ul className="perk-list">
                <li>0% interest.</li>
                <li>No lock in contracts</li>
                <li>Save up to 10% on all dental vouchers ***</li>
                <li>One-off $38 registration fee</li>
                <li>Capped Fee Dentistry</li>
              </ul>
            </div>
          </div>
          <hr />
          <div className='testimonials'>
            <h1>What are people saying about Dental Vouchers</h1>
            {this.testimonials.map((testimonial) => {
              return (
                <div className='testimonial' key={testimonial.key}>
                  <div className='row testimonial-flex'>
                    <div className='author'>
                      <img src={testimonial.image} className='img-circle' />
                    </div>
                    <div className='text'>
                      <p>
                        {testimonial.comment}
                      </p>
                      <p className='testimonial-name'>
                        {testimonial.name}
                      </p>
                    </div>
                  </div>
                </div>
                )
            })}
          </div>
          <FAQ />
          <div class="tandc">
            <p><b>Terms &amp; Conditions</b><br/><br/>The following terms and conditions applies to all Dental Vouchers.</p>
            <ol>
              { termsAndConditions.map((termOrCondition, key) => <li key={key}>{termOrCondition}</li>) }
            </ol>
          </div>
        </div>
      </div>
    )
  }
}

FrontPage.contextTypes = {
  optimizelyToken: PropTypes.string,
  termsAndConditions: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/assets/front-page.js